import { Direction } from "types/battle-engine/battle";

export const vectorToDir = (dx: number, dy: number): Direction => {
  const octant = Math.round(Math.atan2(dy, dx) / (Math.PI / 4));
  const i = octant < 0 ? octant + 8 : octant;

  // Map atan2 octant -> your enum
  const map: Direction[] = [
    Direction.E, // 0 (East)
    Direction.SE, // 1
    Direction.S, // 2
    Direction.SW, // 3
    Direction.W, // 4
    Direction.NW, // 5
    Direction.N, // 6
    Direction.NE, // 7
  ];

  const direction = map[i] as Direction;
  return direction;
};
